import PropTypes from 'prop-types';

import Countdown from '../components/Countdown/Countdown.component';

import styleSheet from './components/styles/scorePredictor.module.scss';
import { useTranslation } from 'react-i18next';

const styles = styleSheet.locals || {};

/**
 * Component for an unopened/scheduled poll
 *
 * @param {object} props poll option props
 * @param {object} props.scorePredictor scorePredictor data
 * @param {boolean} props.scorePredictorScheduled if scorePredictor is scheduled
 * @param {Function} props.onCountdownEnd callback when counter reaches 0
 * @returns {Function} <ScheduledScreen />
 */
function ScheduledScreen({
    scorePredictor,
    scorePredictorScheduled = false,
    onCountdownEnd
}) {
    const { t } = useTranslation();

    const showOpensCountdown =
        scorePredictorScheduled && scorePredictor.opens_at;

    const showClosesCountdown = scorePredictor.closes_at && !showOpensCountdown;

    const showOpensSoon = scorePredictor?.state === 'draft';

    return (
        <div
            data-cy="notOpenMessage"
            part="score-predictor-scheduled"
            className={styles.scorePredictorScheduledText}
        >
            {showOpensCountdown || showClosesCountdown ? (
                <>
                    {showOpensCountdown && (
                        <div
                            className={styles.scorePredictorScheduledCountdown}
                        >
                            <Countdown
                                text={t('scorePredictor.opensIn')}
                                datetime={scorePredictor.opens_at}
                                onCountdownEnd={onCountdownEnd}
                            />
                        </div>
                    )}
                    {showClosesCountdown && (
                        <div
                            className={styles.scorePredictorScheduledCountdown}
                            data-testid="closes-at-countdown"
                        >
                            <Countdown
                                text={t('scorePredictor.closesIn')}
                                datetime={scorePredictor.closes_at}
                                onCountdownEnd={onCountdownEnd}
                            />
                        </div>
                    )}
                </>
            ) : showOpensSoon ? (
                t('scorePredictor.openSoonMessage')
            ) : null}
        </div>
    );
}

ScheduledScreen.propTypes = {
    scorePredictor: PropTypes.bool,
    scorePredictorScheduled: PropTypes.bool,
    onCountdownEnd: PropTypes.func.isRequired
};

export default ScheduledScreen;
